import React from 'react';

// `inert` isn't in this @types/react version yet.
export const inertWhenHidden = (hidden: boolean) =>
  ({ inert: hidden ? '' : undefined }) as unknown as React.HTMLAttributes<HTMLDivElement>;
